<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div id="groupModal" :class="type == 2 ? 'modal-mask' : 'modal-mask1'" @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop  style="max-width: 100%;">
          <div class="modal-content p-2">
            <div class="modal-header px-4 pt-2 pb-0">
              <div class="" style="width: 100%;">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body">
              <div class="modal_reps_to_review d-none-">
                <b-alert
                  :show="dismissCountDown"
                  dismissible
                  variant="success"
                  @dismissed="dismissCountDown=0"
                  @dismiss-count-down="countDownChanged"
                  >
                  {{ success_message }}
                </b-alert>
                <MenteeTaskListComponent 
                  :isModalVisible="isTaskListComponentVisible"
                  @openSkillPassModal="openSkillPassModal"
                  @closeAddRep="closeAddRep"
                  ref="TaskListComponentModal">
                </MenteeTaskListComponent>
                <MenteeSkillPassComponent 
                  :isModalVisible="isSkillPassComponentVisible"
                  @openTaskListModal="openTaskListModal"
                  @closeAddRep="closeAddRep"
                  ref="SkillPassComponentModal">
                </MenteeSkillPassComponent>






              </div>
            </div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </transition>




  </div>
</template>

<script>
import axios from 'axios';
import MenteePathwayProgress from '@/components/manager/mentee_pathway_progress.vue';
import MenteeTaskListComponent from '@/components/manager/mentee_tasklist_component.vue';
import MenteeSkillPassComponent from '@/components/manager/mentee_skillpass_component.vue';

export default {
  props: ['isModalVisible', 'type'],
  data() {
    return {
      menteeFirstName: '',
      menteeShortName: '',
      repCount: '',
      repTasks: '',
      mentorsAssigned: [],
      viewAll: false,
      searchText: '',
      subtasks: [],
      focusedSubtasks: [],
      searchTextFlag: false,
      tasklists_loading: false,
      tasklists_focus_loading: false,
      taskListsName: '',
      menteeId: '',
      taskListId: '',
      isTaskListComponentVisible: false,
      isSkillPassComponentVisible: false,
      success_message: '',
      dismissCountDown: 0,
      menteePathway: {},
    }
  },
  computed: {
    
  },
  methods: {
    closeAddRep() {
      this.$emit('closeAddRep');
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    toggleViewAll() {
      this.viewAll = !this.viewAll;
    },
    hide() {
      this.$emit('closeTaskListModal');
    },
    openSkillPassModal() {
      this.isTaskListComponentVisible = false;
      this.isSkillPassComponentVisible = true;
      this.$refs.SkillPassComponentModal.getTaskListData(this.menteeId, this.taskListId, this.menteeShortName);
    },
    openTaskListModal(flag) {
      this.isSkillPassComponentVisible = false;
      this.isTaskListComponentVisible = true;
      if(flag == 1) {
        this.success_message = 'Rep added successfully.';
        this.dismissCountDown = 5;
      }
      this.$refs.TaskListComponentModal.getTaskListData(this.menteeId, this.taskListId);
    },
    getMenteeTasklistsData(menteeId, taskListId) {
      this.menteeId = menteeId;
      this.taskListId = taskListId;
      axios('/desktop/v2/get-mentee-details', {
        method: 'GET',
        params: {
          mentee_id: this.menteeId,
          accountId: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        let data = resp.data;
        this.menteeFirstName = data.mentee_first_name;
        this.menteeShortName = data.mentee_short_name;
        this.mentorsAssigned = data.mentors_assigned;
        this.menteePathway = data.menteePathway;
      })
      .catch(() => {});
      this.isTaskListComponentVisible = true;
      this.isSkillPassComponentVisible = false;
      this.$refs.TaskListComponentModal.getTaskListData(this.menteeId, taskListId);
      setTimeout(() => {
        let element = document.getElementById('groupModal');    
        element.scrollIntoView(true);
      }, 2000); 
    },
  },
  components: {
    MenteePathwayProgress,
    MenteeTaskListComponent,
    MenteeSkillPassComponent,
    MenteePathwayProgress,
  },
  created() {

  },
  mounted() {

  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}

::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-mask1 {
    position: fixed;
    z-index: 1001;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
@media (min-width: 1200px) {
  .modal-lg {
    width: 690px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 690px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/manager/mentee_tasklists_new.vue